<!-- 企业级-用户管理-组织管理-权限分配 -->
<template>
  <div class="mainArea COrganizeAuthAllot">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 权限列表 -->
        <el-tree
          class="roleTree"
          v-loading="roleAuthData.loading"
          ref="role"
          :data="roleAuthData.list"
          :props="defaultProps"
          node-key="function_id"
          :default-checked-keys="roleAuthData.roleAccess"
          show-checkbox
          default-expand-all>
        </el-tree>

        <!-- 确认 -->
        <el-button
          class="confirm"
          type="primary"
          @click="getCheckedKeys"
          v-if="roleAuthData.list.length !== 0">确 认</el-button>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../../static/js/api.js"
  import * as expConfig from "../../../../../static/js/exp/config.js"
  import { expUserApi } from "../../../../../static/js/exp/user.js"

  export default {
    name: 'ExpCOrganizeAuthAllot',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        // 角色权限数据
        roleAuthData: {
          // 权限列表
          list: [],
          loading: false,
          // 已选中权限
          roleAccess: []
        },
        // 树形控件默认控件
        defaultProps: {
          children: 'children',
          label: 'function_name'
        }
      }
    },
    mounted(){
      this.getRoleAuth()
    },
    created: async function () {
    },
    methods: {
      // 获取角色权限详情
      getRoleAuth: async function () {
        let vm = this
        let data = expConfig.roleAuthData
        vm.roleAuthData.list = [...data.companyAccessList]
        vm.roleAuthData.roleAccess = [...data.roleAccess]
      },
      // 更新角色权限
      updateRoleAuth: async function (roleAccess) {
        let vm = this
        vm.$store.state.authSuccessShowTab = 'auth'
        vm.$router.go(-1)
      },
      // 确认更新权限
      getCheckedKeys() {
        let roleAccess = this.$refs.role.getCheckedKeys()
        // console.log('roleAccess', roleAccess)
        this.updateRoleAuth(roleAccess)
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.COrganizeAuthAllot {
  .roleTree>.el-tree-node {
      margin-bottom: 20px;
  }

  .roleTree .el-tree-node__children>.el-tree-node {
      float: left;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ExpPage/CUserManege/COrganizeManage/COrganizeAuthAllot.vue